export default __webpack_public_path__ + "static/media/slide18.e00e545a.jpg";